<template>
    <!-- ======= Header ======= -->
    <header id="header" class="header fixed-top d-flex align-items-center" style="padding-left:6px;padding-right:2%;">
        <div class="d-flex align-items-center justify-content-between">
            <i @click="navbar" class="bi bi-list toggle-sidebar-btn" style="float:right"></i>
            <a href="http://modspec.com.au/" class="align-items-center">
                <img id="imgLogo" src="@/assets/images/wordmark2.svg" alt="" />
            </a>
        </div>

        <nav class="header-nav ms-auto">
            <ul class="nav" style="display:block;position:relative;float:right;">

                <li v-if="props.behavior == 'user'" class="nav-item dropdown"
                    style="width:auto;float:right;margin-left:10px;">
                    <div class="box-menu">
                        <a href="#" class="nav-link link-modspec modspec_menu" style="height: 40px;padding-left:10px;"
                            title="User" data-bs-toggle="dropdown">
                            <span class="d-md-block dropdown-toggle ps-2"><img class="icon"
                                    src="@/assets/images/user.svg" /> <span class="username">{{ username
                                    }}</span></span>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li>
                                <a class="dropdown-item d-flex align-items-center" href="#" @click="logout">
                                    <span class="nav-link link-modspec">Log out</span>
                                </a>
                            </li>
                        </ul>

                    </div>
                </li>
                <li v-if="props.behavior == 'user'" class="nav-item dropdown"
                    style="width:auto;float:right;margin-left:10px;">
                    <div class="box-menu">
                        <a v-tooltip="{ text: 'Back to website', theme: { placement: 'bottom', color: '#fff', 'background-color': '#2a2c2e', 'font-size': '0.875rem', width: 'fit-content', padding: '5px', } }"
                            class="nav-link link-modspec modspec_menu" href="http://modspec.com.au/"
                            style="font-size:1.3rem !important; font-weight: 600;color:#000;padding-top:0.3rem"><i
                                class="bi bi-house-door-fill"></i></a>
                    </div>
                </li>

                <!---------------------------------------->
                <li v-if="props.behavior == 'admin'" class="nav-item dropdown pe-3">
                    <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                        <span class="d-none d-md-block dropdown-toggle ps-2">{{
                            username
                            }}</span> </a><!-- End Profile Iamge Icon -->

                    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                        <li class="dropdown-header">
                            <h6>Admin - {{ username }}</h6>
                        </li>
                        <li>
                            <hr class="dropdown-divider" />
                        </li>

                        <li>
                            <a class="dropdown-item d-flex align-items-center" href="#" @click="logout">
                                <i class="bi bi-box-arrow-right"></i>
                                <span class="nav-link link-modspec">Sign Out</span>
                            </a>
                        </li>
                    </ul>
                    <!-- End Profile Dropdown Items -->
                </li>

            </ul>

        </nav>
    </header>

    <!-- ======= Sidebar ======= -->
    <aside id="sidebar" class="sidebar expanded p-2">
        <ul v-if="props.behavior == 'admin'" class="sidebar-nav" id="sidebar-nav">
            <li v-if="isAdminOrSuperAdmin" class="nav-item mt-3">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/"><i
                        class="bi bi-window-fullscreen" style="color:inherit !important"></i>
                    <span>Dashboard</span>
                </router-link>
            </li>
             <li v-else class="nav-item mt-3">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/consultant"><i
                        class="bi bi-window-fullscreen" style="color:inherit !important"></i>
                    <span>Dashboard</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/clients"><i
                        class="bi bi-people" style="color:inherit !important"></i>
                    <span>Clients</span>
                </router-link>
            </li>

            <li v-if="isAdminOrSuperAdmin" class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/configuration/"><i
                        class="bi bi-gear" style="color:inherit !important"></i>
                    <span>Settings</span>
                </router-link>
            </li>
            <!-- <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/templates/"><i
                        class="bi bi-envelope" style="color:inherit !important"></i>
                    <span>Email Templates</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/administration/users/"><i
                        class="bi bi-person" style="color:inherit !important"></i>
                    <span>Admin Users</span>
                </router-link>
            </li> -->
        </ul>
        <!------>
        <ul v-else class="sidebar-nav" id="sidebar-nav">
            <li class="nav-item mt-3">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/user/"><i class="bi bi-pen-fill"
                        style="color:inherit !important"></i>
                    <span>Quotes</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/user/projects"><i
                        class="bi bi-grid" style="color:inherit !important"></i>
                    <span>Projects</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link  link-modspec" to="/user/constructions"><i
                        class="bi bi-building-fill" style="color:inherit !important"></i>
                    <span>Libraries</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link @click="clickNavBar" class="nav-link link-modspec" to="/user/users"><i class="bi bi-person"
                        style="color:inherit !important"></i>
                    <span>Users</span>
                </router-link>
            </li>
        </ul>
    </aside>
    <!-- End Sidebar-->



</template>
<script setup>
import vtc from "@/helpers/vtc.js";
import { ref, defineProps, onMounted, computed } from "vue";

const username = ref('')
const roles = ref([])

const props = defineProps({
    behavior: {
        type: String,
        default: "user"
    }
})

onMounted(async () => {
    username.value = vtc.getNameLogueado();
    roles.value = getLoggedRoles();
});

const getLoggedRoles = () => {
    const user = vtc.getUsuarioLogueado();
    const roleValue =  user?.rol 

    if (Array.isArray(roleValue)) {
        return roleValue.map((role) => String(role).toLowerCase());
    }

    return String(roleValue)
        .split(",")
        .map((role) => role.trim().toLowerCase())
        .filter((role) => role !== "");
}

const isAdminOrSuperAdmin = computed(() => {
    return roles.value.includes("admin") || roles.value.includes("superadmin");
})

const navbar = () => {

    const sidebar = document.getElementById('sidebar');
    sidebar.classList.toggle('collapsed');
    sidebar.classList.toggle('expanded');
}
const clickNavBar = () => {
    if (isMobile.value) {
        navbar();
    }
}

const isMobile = computed(() => {
    if (screen.width <= 760) {
        return true;
    } else {
        return false;
    }
})

const logout = async () => {
      let usr = vtc.getUserToken();

      vtc.deleteUserLogueado(); //-QUITAR luego de pruebas

        await vtc.vtcFetch("/Auth/Logout?u=" + usr, null, 'API2')        
        vtc.deleteUserLogueado();

        window.location.href = vtc.getConfig().getHomeUrl() + "/login";
        
    }

</script>
<style>
#header {
    height: 70px;
}

.link-modspec {
    font-size: 13px !important;
    font-weight: 600;
    color: #000 !important;
}

.icon {
    width: 24px;
    height: 24px;
}

.box-menu {
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    box-sizing: border-box;
    border: 1px solid #aaa;
    border-radius: 10px;
    height: 40px;
}

#imgLogo {
    width: 140px;
    height: 60px;
    margin-top: 2%;
    margin-left: 30px;
    position: static;
}

@media only screen and (max-width: 575px) and (max-width: 991px) {
    .username {
        display: none;
    }
}



body {
    overflow-x: hidden;
}

aside.sidebar {
    height: 100vh;
    transition: width 0.3s;
}

aside.sidebar.expanded {
    width: 260px;
}

aside.sidebar.collapsed {
    width: 70px;
}

aside.sidebar .nav-link {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    white-space: nowrap;
    transition: all 0.3s;
}

aside.sidebar .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.sidebar-nav .nav-link i {
    margin-left: 2px;
}

/* Oculta los textos en modo colapsado */
aside.sidebar.collapsed .nav-link span {
    display: none;
}

/* Ajusta el contenido principal */
main.content {
    transition: margin-left 0.3s;
    margin-left: 260px;
}

aside.sidebar.collapsed~main.content {
    margin-left: 70px;
}
</style>
